"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口日志模块
var _default = exports.default = {
  getLogList: function getLogList(data) {
    return (0, _request.default)({
      url: '/protected/apiLog/list',
      method: 'post',
      data: data
    });
  },
  getLogDetail: function getLogDetail(id, systemSuffix) {
    return (0, _request.default)({
      url: '/protected/apiLog/query/' + systemSuffix + '/' + id,
      method: 'get'
    });
  }
};